// const url = '/cities';
export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': 'fa3a6d16d6mshe9b66544779d113p1de37djsn3c4c2a4d505a',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};


export const GEO_API_URL="https://wft-geo-db.p.rapidapi.com/v1/geo";

export const Weather_API_URL="https://api.openweathermap.org/data/2.5";
export const Weather_API_ID="991546376cdc95401309675e06b463e1";


